import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ALLOWED_MIME_TYPES } from '@app/core/constants';
import { toBase64 } from '@app/common';

import { MatRippleModule } from '@angular/material/core';
import { UploadedFile } from './models';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatRippleModule,
    TranslateModule
]
})
export class FileUploadComponent {
  @Input() type: 'button' | 'icon' | 'field' = 'button';
  @Input() urlImg: string;
  @Input() multiple: boolean = true;
  @Output() filesChanged = new EventEmitter<UploadedFile[]>();
  @ViewChild('fileInput') fileInput: ElementRef;

  readonly allowedMIMETypes = ALLOWED_MIME_TYPES;

  async fileUploaded(event: Event): Promise<void> {
    const loadedFiles: UploadedFile[] = [];

    const files = (event.target as HTMLInputElement).files;

    for (let i = 0; i < files.length; i++) {
      await toBase64(files[i]).then(file => {
        loadedFiles.push({ name: files[i].name, file });
      });
    }

    this.filesChanged.emit(loadedFiles);

    if (this.type === 'field') {
      this.urlImg = loadedFiles[0]?.file;
    }

    this.fileInput.nativeElement.value = null;
  }

  removeFiles(): void {
    this.urlImg = undefined;
    this.filesChanged.emit([]);
  }

  openDialogUpload(): void {
    this.fileInput.nativeElement.click();
  }
}
